module.exports = __webpack_public_path__ + "static/media/local_venue.08e7186b.JPG";